import { Component, OnInit, inject, signal } from '@angular/core';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';
import { ReductionActionsComponent } from './reduction-actions/reduction-actions.component';
import { CustomActionsComponent } from './custom-actions/custom-actions.component';
import { SdgPickerComponent } from './sdg-picker/sdg-picker.component';

/**
 * "My commitments" tab. Three independent concerns, deliberately kept apart:
 * reduction actions (linked to reduction tips), free-text custom actions, and
 * SDG selection. Each has its own component, service and endpoint.
 */
@Component({
  selector: 'app-climate-actions',
  standalone: true,
  imports: [ReductionActionsComponent, CustomActionsComponent, SdgPickerComponent],
  templateUrl: './climate-actions.component.html',
})
export class ClimateActionsComponent implements OnInit {
  private currentUserService = inject(CurrentUserService);

  isLoading = signal(true);

  ngOnInit(): void {
    this.currentUserService.loadCurrentUser().subscribe(() => {
      this.isLoading.set(false);
    });
  }
}
